/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Right_Justify_Right_PosInputs */

const en_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right Justify / Right Position`)
};

const fr_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Droite / Position Droite`)
};

const de_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtsbündig / Rechtsposition`)
};

const it_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giustifica a destra / Posizione corretta`)
};

const ru_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Правильное обоснование / Правильное положение`)
};

const es_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificación a la derecha / Posición correcta`)
};

const zh_cn2_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右对齐 / 右对齐`)
};

const ja_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右揃え / 右位置`)
};

const hi_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाएँ औचित्य / दाएँ स्थिति`)
};

const pt_pt2_align_right_right_justify_right_pos = /** @type {(inputs: Align_Right_Right_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar à direita / Posicionamento correto`)
};

/**
* | output |
* | --- |
* | "Right Justify / Right Position" |
*
* @param {Align_Right_Right_Justify_Right_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_right_justify_right_pos = /** @type {((inputs?: Align_Right_Right_Justify_Right_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Right_Justify_Right_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_right_right_justify_right_pos(inputs)
	if (locale === "de") return de_align_right_right_justify_right_pos(inputs)
	if (locale === "it") return it_align_right_right_justify_right_pos(inputs)
	if (locale === "ru") return ru_align_right_right_justify_right_pos(inputs)
	if (locale === "es") return es_align_right_right_justify_right_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_right_right_justify_right_pos(inputs)
	if (locale === "ja") return ja_align_right_right_justify_right_pos(inputs)
	if (locale === "hi") return hi_align_right_right_justify_right_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_right_right_justify_right_pos(inputs)
	return en_align_right_right_justify_right_pos(inputs)
});